export const PIN = 'PinReset';
export const LINK = 'LinkReset';



// WEBPACK FOOTER //
// ./src/data/resetTypes.js